import type React from "react";
import { useState } from "react";

import { styled } from "simplydo/react/styled";
import { Icon } from "simplydo/react/ui";

const GiphyOverlay = styled.div`
  display: inline-block;

  max-width: 200px;
  height: 150px;
  max-height: 150px;

  overflow: hidden;
  position: relative;
  margin: 0 3px;
  img {
    display: block;
    object-fit: contain;
    height: 100%;
    width: 100%;
  }
  .delete-icon {
    position: absolute;
    top: 0px;
    right: 0px;
  }
`;

export type GiphyGifData = {
  url?: string;
  title?: string;
  images?: {
    fixed_width_small?: { url: string };
    fixed_width?: { url: string };
  };
};

type GiphyGifProps = {
  gif?: GiphyGifData | Record<string, unknown> | null;
  size: string;
  onClickGif?: () => void;
  canDelete?: boolean;
  style?: React.CSSProperties;
};

const getSizedUrl = (gif: GiphyGifData, size: string) => {
  switch (size) {
    case "fixed_small":
      return gif.images?.fixed_width_small?.url ?? gif.url ?? "";
    case "fixed":
      return gif.images?.fixed_width?.url ?? gif.url ?? "";
    default:
      return gif.images?.fixed_width?.url ?? gif.url ?? "";
  }
};

export const GiphyGif = ({
  gif,
  size,
  onClickGif,
  canDelete,
  style,
}: GiphyGifProps) => {
  const [imageHover, setHovered] = useState(false);
  const gifUrl =
    !gif ? ""
    : !size ? ((gif as GiphyGifData).url ?? "")
    : getSizedUrl(gif as GiphyGifData, size);
  return (
    <GiphyOverlay
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClickGif}
      className={canDelete ? "giphy-overlay" : undefined}
    >
      <img
        style={{
          cursor: onClickGif ? "pointer" : undefined,
          borderRadius: 5,
          ...(style || {}),
        }}
        src={gifUrl}
        alt={(gif as GiphyGifData).title || "Gif"}
      />
      {imageHover && canDelete && (
        <Icon inverted circular name="close" className="delete-icon" />
      )}
    </GiphyOverlay>
  );
};
